package chat.amp.tim

import de.connect2x.trixnity.messenger.util.DownloadManager
import de.connect2x.messenger.compose.view.roomlist.RoomListContainerView
import de.connect2x.messenger.compose.view.theme.ThemeComponents
import kotlinx.coroutines.CoroutineScope
import org.koin.dsl.module

fun ampModule() = module {
    single<RoomListContainerView> { ampRoomListContainerViewImpl() }
    single<ThemeComponents> { ampThemeComponentsImpl() }
    // include if content scanning should be activated in the app
    //single<DownloadManager> { ampDownloadManagerImpl(get<CoroutineScope>().coroutineContext) }
}
